var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"starter-page"},[_c('div',{staticClass:"section text-center"},[_c('h3',[_vm._v("Create your next awesome website")])])])}]

export { render, staticRenderFns }